import React from 'react';

import { DetailsList, DetailsListItem } from '@eika/details-list';
import { useViewType, ViewType } from '@eika/hooks';

import ErrorCardWrapper from '../../components/ErrorCardWrapper';
import LoanInterest from '../../components/LoanInterest/LoanInterest';
import LoanOwnersDesktop from '../../components/LoanOwnersDesktop/LoanOwnersDesktop';
import useAccountId from '../../hooks/useAccountId';
import { useLoanDetails } from '../../hooks/useLoans';
import { useTranslation } from '../../translations';

import './LoanOwners.scss';

const LoanOwners: React.FC = () => {
    const accountId = useAccountId();
    const { data: loan, isLoading, error } = useLoanDetails(accountId);
    const { loanOwners: translated } = useTranslation();
    const viewType = useViewType();

    if (error) {
        return (
            <div className="sgw-content">
                <ErrorCardWrapper exception={error} />
            </div>
        );
    }

    if (!loan && !isLoading) return null;

    if (viewType === ViewType.mobile) {
        return (
            <div className="sgw-content">
                <DetailsList title={translated.title} isLoading={isLoading} skeletonCount={1}>
                    {loan?.accountRoles.map((role) => (
                        <DetailsListItem
                            key={translated.accountRole[role.accountRoleType] + role.customerName}
                            label={translated.accountRole[role.accountRoleType]}
                            value={role.customerName}
                        />
                    ))}
                </DetailsList>
                <LoanInterest interestRates={loan?.interestsRates} isLoading={isLoading} accountId={loan?.accountId} />
            </div>
        );
    }

    return (
        <>
            <LoanOwnersDesktop accountRoles={loan?.accountRoles} isLoading={isLoading} />
            <div className="loan-interest-container">
                <LoanInterest interestRates={loan?.interestsRates} isLoading={isLoading} accountId={loan?.accountId} />
            </div>
        </>
    );
};

export default LoanOwners;
